import SearchService from '@services/search-service';
import { usePreferences } from '@context/preferences.context';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { ElasticSearch, ElasticSearchFacetsFields } from '@interfaces/models/elasticSearch';
import { ElasticSearchFacet } from '@interfaces/api/responses/elasticSearch';

export type SearchFacetsInput = {
  searchTerm: string;
  filtersForPayload: ElasticSearch['filters'];
};

const useFacetSearch = ({ filterGroup }: { filterGroup: ElasticSearchFacetsFields }) => {
  const { country, currency, language, regionName } = usePreferences();
  const searchQuery = useContextSelector(CatalogContext, (v) => v.searchQuery);

  const searchFacets = async ({
    searchTerm,
    filtersForPayload,
  }: SearchFacetsInput): Promise<ElasticSearchFacet[] | null> => {
    if (!(filterGroup === 'model' || filterGroup === 'brand') || !searchTerm) {
      return null;
    }

    const { items } = await SearchService.facetSearch({
      facetName: filterGroup,
      facetQuery: searchTerm,
      filters: filtersForPayload,
      q: filterGroup === 'brand' && searchQuery ? searchQuery : '',
      locale: {
        country,
        currency,
        language,
        sizeType: regionName,
      },
    });
    return [
      ...items.map((e) => {
        const [name, id] = e.name.split('#');

        return {
          id: id,
          name: name,
          count: e.count,
        };
      }),
    ];
  };

  return { searchFacets };
};

export default useFacetSearch;
